import {Header} from '../../partials/header';

window.addEventListener('load', () => {
  Header.onload();
});